/** @format */

import QRCode from '../../Shared/Components/QRCode';
const QRCodeField = ({ onChangeValue, fieldChange, eventContext }) => {
	
	return (
		<div className='col-12'>
			<div className='d-flex flex-column my-1 justify-content-center border rounded p-2'>
				<span className='text-dark f-14 border-bottom py-2 text-center'>
					QR Code
				</span>
				<div className='d-flex flex-row my-2 justify-content-around align-content-center'>
					<div className='form-group w-50 align-self-center'>
						<label>لینک</label>
						<input
							className='form-control text-right'
							placeholder='https://example.com'
							value={eventContext.idCardFields?.qrCode?.url ?? ""}
							onChange={(e) =>
								onChangeValue('url', e.target.value, fieldChange.qrCode)
							}
						/>
					</div>
					<QRCode
						value={eventContext.idCardFields?.qrCode?.url}
						width='120'
						height='120'
					/>
				</div>
				<div className='d-flex flex-row justify-content-around'>
					<div className='form-group my-2 mx-1'>
						<label>عرض</label>
						<input
							type='number'
							value={eventContext.idCardFields?.qrCode?.width}
							onChange={(e) =>
								onChangeValue('width', e.target.value, fieldChange.qrCode)
							}
							className='form-control f-12'
						/>
					</div>
					<div className='form-group my-2 mx-1'>
						<label>ارتفاع</label>
						<input
							type='number'
								value={eventContext.idCardFields?.qrCode?.height}
							onChange={(e) =>
								onChangeValue('height', e.target.value, fieldChange.qrCode)
							}
							className='form-control f-12'
						/>
					</div>
				</div>
				<div className='d-flex flex-row justify-content-around'>
					<div className='form-group my-2 mx-1'>
						<label>فاصله از بالا</label>
						<input
							type='number'
									value={eventContext.idCardFields?.qrCode?.top}
							onChange={(e) =>
								onChangeValue('top', e.target.value, fieldChange.qrCode)
							}
							className='form-control f-12'
						/>
					</div>
					<div className='form-group my-2 mx-1'>
						<label>فاصله از راست</label>
						<input
							type='number'
							value={eventContext.idCardFields?.qrCode?.right}
							onChange={(e) =>
								onChangeValue('right', e.target.value, fieldChange.qrCode)
							}
							className='form-control f-12'
						/>
					</div>
				</div>
				<div className='d-flex flex-row justify-content-around'>
					<div className='form-group my-2 mx-1'>
						<label>فاصله از چپ</label>
						<input
							type='number'
							value={eventContext.idCardFields?.qrCode?.left}
							onChange={(e) =>
								onChangeValue('left', e.target.value, fieldChange.qrCode)
							}
							className='form-control f-12'
						/>
					</div>
					<div className='form-group my-2 mx-1'>
						<label>فاصله از پایین</label>
						<input
							type='number'
							value={eventContext.idCardFields?.qrCode?.bottom}
							onChange={(e) =>
								onChangeValue('bottom', e.target.value, fieldChange.qrCode)
							}
							className='form-control f-12'
						/>
					</div>
				</div>
				{/*<div className='d-flex flex-row'>
   <button className='d-flex flex-row justify-content-center btn text-center align-content-center f-12 btn-info d-flex my-2 form-control'>
       اضافه کردن
   </button>
</div>*/}
			</div>
		</div>
	);
};

export default QRCodeField;
